/* eslint-disable react/destructuring-assignment */

import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import Button from './button';

export interface CopyButtonProps {
  text: string;
  displayValue?: string;
  onClick?: () => void;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class CopyButton extends React.Component<CopyButtonProps> {
  public render() {
    return (
      <CopyToClipboard text={this.props.text}>
        <Button text={this.props.displayValue || 'Copy'} onClick={this.props.onClick} />
      </CopyToClipboard>
    );
  }
}
